import React, { PureComponent } from "react";
import OneColumnLayout from "../../layouts/one-column";
import BalanceSheetWidget from "../../../finance/widgets/balance-sheet";

class TeamReportsSection7Step2 extends PureComponent {
  get content() {
    const { balanceSheet, current_year } = this.props;

    return (
      <BalanceSheetWidget
        balanceSheet={balanceSheet}
        current_year={current_year}
        className="team-reports-with-scroll-2"
      />
    );
  }

  render() {
    return <OneColumnLayout title="Balance Sheet" content={this.content} />;
  }
}

export default TeamReportsSection7Step2;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-7/step-3.js